module.exports = __webpack_public_path__ + "static/media/animalCiclo6.357ced52.png";